import React from 'react';
import { Link } from 'gatsby';
import { Container, Row, Col } from 'react-bootstrap';

import StrapiSocialMediaLink from '../../../components/link/social-media-link';

import { FooterQuery } from '../../../models/strapi/stateLandingPageQuery';

import * as styles from './footer.module.scss';

const Footer = ({ data, usingMouse }: { data: FooterQuery; usingMouse: boolean }) => {
    return (
        <footer className={styles.footerFlexbox}>
            <Container>
                <Row className={styles.bottomBannerContainer}>
                    <Col md={12} lg={5} className={styles.links}>
                        <Link className={usingMouse ? 'using-mouse' : ''} to='/privacy-policy'>
                            Privacy Policy
                        </Link>
                        <span className={styles.pipe}>|</span>
                        <Link className={usingMouse ? 'using-mouse' : ''} to='/terms-of-service'>
                            Terms of Service
                        </Link>
                    </Col>
                    <Col md={12} lg={2} className={styles.icons}>
                        {data.social_media_links.map((link, i) => (
                            <StrapiSocialMediaLink link={link} key={i} usingMouse={usingMouse} />
                        ))}
                    </Col>
                    <Col md={12} lg={5} className={styles.copyright}>
                        <span>Copyright © 2020 Curaleaf™ (or its affiliates or licensors).</span>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
